import Vue from "vue";

class Toasts extends Vue {
    public success(content: string, autoHideDelay: number) {
        this.toast("success", content, "fa-check-circle color-green", autoHideDelay);
    }

    public failure(content: string, autoHideDelay: number) {
        this.toast("danger", content, "fa-exclamation-triangle color-red", autoHideDelay);
    }

    public warning(content: string, autoHideDelay: number) {
        this.toast("warning", content, "fa-exclamation-triangle color-orange", autoHideDelay);
    }

    // autoHideDelay -- set to 0 for no hiding.
    private toast(variant: string, content: string, iconClass: string, autoHideDelay: number) {
        const vNodesTitle = this.$createElement(
            "div",
            {class: ["d-flex", "align-items-start", "toaster-text"]},
            [
                this.$createElement("i", {
                    class: ["fas", iconClass],
                }),
                this.$createElement("div", content),
            ]
        );

        this.$bvToast.toast(` `, {
            title: [vNodesTitle],
            variant: variant,
            solid: true,
            toaster: "b-toaster-bottom-right",
            autoHideDelay: autoHideDelay,
            appendToast: true,
            noAutoHide: autoHideDelay === 0
        });
    }
}


const toasts = {
    toasts: null as null | Toasts,
    success(content: string, autoHideDelay = 5000) {
        this.ensureToasts().success(content, autoHideDelay);
    },
    failure(content: string, autoHideDelay = 5000) {
        this.ensureToasts().failure(content, autoHideDelay);
    },
    warning(content: string, autoHideDelay = 5000) {
        this.ensureToasts().warning(content, autoHideDelay);
    },
    ensureToasts() {
        this.toasts = this.toasts ?? new Toasts();
        return this.toasts;
    }
};

export default toasts;